import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import moment from "moment";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const BloodPressureChart = ({ bloodPressureData }) => {
  const data = {
    labels: bloodPressureData.map((d) => moment(d.date).format("D MMM")),
    datasets: [
      {
        label: "Systolic",
        data: bloodPressureData.map((d) => d.systolic),
        backgroundColor: "#36A2EB", // blue
      },
      {
        label: "Diastolic",
        data: bloodPressureData.map((d) => d.diastolic),
        backgroundColor: "#FF6384", // red
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "top" },
      tooltip: {
        callbacks: {
          label: function (context) {
            const unit = bloodPressureData[context.dataIndex].unit;
            return `${context.dataset.label}: ${context.raw} ${unit}`;
          },
          footer: function (tooltipItems) {
            let systolic = tooltipItems.find(t => t.dataset.label === "Systolic")?.raw || 0;
            let diastolic = tooltipItems.find(t => t.dataset.label === "Diastolic")?.raw || 0;
            return `BP: ${systolic}/${diastolic} mmHg`;
          },
        },
      },
    },
    scales: {
      x: { stacked: false, title: { display: true, text: "Date" } },
      y: {
        stacked: false,
        beginAtZero: true,
        title: { display: true, text: "Blood Pressure (mmHg)" },
      },
    },
  };

  return (
    <div className="card shadow-sm mb-4 h-full">
      <div className="card-header text-center text-xl font-bold text-gray-700">
        Blood Pressure Chart
      </div>
      <div className="card-body" style={{ height: "300px" }}>
        {bloodPressureData && bloodPressureData.length > 0 ? (
          <Bar data={data} options={options} />
        ) : (
          <p className="text-gray-500 font-semibold flex items-center justify-center h-full">
            No data found for selected criteria
          </p>
        )}
      </div>
    </div>
  );
};

export default BloodPressureChart;
